module.exports = __webpack_public_path__ + "static/media/Outdoor_1.afde7d49.jpeg";